import mirrorCreator from "mirror-creator";

export default mirrorCreator(["READ_ALL_CHATS", "READ_CHAT", "TOGGLE_FAVORITE_CHAT"]);
